import { isDefined } from "@ls/js-utils";
import CalcType from "state/Constants/CalcType";
import ScaleType from "state/Constants/ScaleType";

export const splitByCalcType = (definitions) => {
  const abs = [],
    bmk = [],
    rel = [];
  definitions.forEach((definition) => {
    switch (definition.calcType) {
      case CalcType.Account:
        abs.push(definition);
        break;
      case CalcType.Benchmark:
        bmk.push(definition);
        break;
      case CalcType.Relative:
        rel.push(definition);

        break;
      default:
        throw new Error(
          `Unknown calcType ${JSON.stringify(definition.calcType)}`
        );
    }
  });
  return [abs, bmk, rel];
};

export const getRatioTypeDefinitions = (definitions) => {
  return definitions.filter(
    (definition) => definition.scaleType === ScaleType.Ratio
  );
};

export const getEntitySummariesObject = (node, entityId, isRelative) => {
  if (isDefined(node?.securityId)) {
    const entityResultMetaData =
      node?.positionSummary?.entityResultMetaData ?? {};
    if (
      entityResultMetaData.entityId === entityId &&
      entityResultMetaData.relative === isRelative
    ) {
      return node.positionSummary;
    }
  } else {
    return node?.entitySummaries?.find(
      ({ entityResultMetaData = {} }) =>
        entityResultMetaData.entityId === entityId &&
        entityResultMetaData.relative === isRelative
    );
  }
};

export const getEntitySummariesObjectForBench = (
  node,
  entityId,
  benchValue,
  isRelative
) => {
  if (isDefined(node?.securityId)) {
    const entityResultMetaData =
      node?.positionSummary?.entityResultMetaData ?? {};
    if (benchValue === 0) {
      if (
        entityResultMetaData.entityId === entityId &&
        entityResultMetaData.relative === isRelative &&
        entityResultMetaData.benchId === 0
      ) {
        return node.positionSummary;
      }
    } else {
      if (
        entityResultMetaData.entityId === entityId &&
        entityResultMetaData.relative === isRelative &&
        entityResultMetaData.benchId > 0
      ) {
        return node.positionSummary;
      }
    }
  } else {
    if (benchValue === 0) {
      return node?.entitySummaries?.find(
        ({ entityResultMetaData = {} }) =>
          entityResultMetaData.entityId === entityId &&
          entityResultMetaData.relative === isRelative &&
          entityResultMetaData.benchId === 0
      );
    } else {
      return node?.entitySummaries?.find(
        ({ entityResultMetaData = {} }) =>
          entityResultMetaData.entityId === entityId &&
          entityResultMetaData.relative === isRelative &&
          entityResultMetaData.benchId > 0
      );
    }
  }
};
